/**
 * marca.js — o nome da plataforma, e como ele muda por vertical
 * CI Sistemas de Informática Ltda. — AcessoiD (Onda 79)
 *
 * Até 12/09/2026 a plataforma se apresentava como "Gestão de Estacionamento"
 * em toda instalação. O Ipê Clube está em produção como `clube_social` desde
 * 08/09 e exibia exatamente isso na aba do navegador — o nome de outro negócio,
 * para um associado de clube.
 *
 * A marca é uma só, **AcessoiD**, guarda-chuva dos sistemas da casa (é o
 * domínio, e é o mesmo de `refeicoes`, `xgym` e os demais). O que muda entre
 * instalações é o descritor, e ele vem daqui.
 *
 * `FastALPR` não aparece: é o motor de leitura, não o produto. Quem opera a
 * guarita não precisa saber o nome do componente que lê a placa.
 */

export const MARCA = 'AcessoiD';

/** Descritor por vertical. A chave é a mesma que o backend devolve no login. */
const DESCRITORES = {
  estacionamento: 'Estacionamento',
  clube_social: 'Clube Social',
  condominio: 'Condomínio',
};

/**
 * Descritor da instalação, ou string vazia enquanto a vertical não é conhecida
 * — antes do login, por exemplo. Nunca inventa um padrão: dizer
 * "Estacionamento" para quem ainda não se identificou repetiria o defeito que
 * esta onda corrige.
 */
export function descritorDaVertical(vertical) {
  return DESCRITORES[vertical] || '';
}

/**
 * O título da aba. Com o nome do cliente (Onda 123) ele vem primeiro — "G2 Parking — AcessoiD" —
 * porque a aba mostra só o começo do título, e é o cliente que distingue uma aba da outra quando
 * as três instalações estão abertas. Sem ele: "AcessoiD — Clube Social", ou só "AcessoiD".
 */
export function nomeCompleto(vertical, cliente = '') {
  const c = String(cliente || '').trim();
  if (c) return `${c} — ${MARCA}`;
  const d = descritorDaVertical(vertical);
  return d ? `${MARCA} — ${d}` : MARCA;
}
